import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const adobe = defineConnector({
  identifier: "adobe",
  name: "Adobe",
  tagLine: "Creative and document services",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://ims-na1\\.adobelogin\\.com/ims/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an Adobe app",
      items: [
        {
          kind: "markdown",
          content:
            "Open [Adobe Developer Console](https://developer.adobe.com/console/home), create a new project, and add the Adobe API you want to use. Copy the client ID and client secret from the project credentials page.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/adobe/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Configure scopes",
      items: [
        {
          kind: "input",
          label: "Scopes",
          placeholder: "offline_access",
          helperText: "Space-separated list of permission scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your Adobe account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Adobe account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://ims-na1.adobelogin.com/ims/authorize/v2",
    tokenEndpoint: () => "https://ims-na1.adobelogin.com/ims/token/v3",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://ims-na1.adobelogin.com/ims/",
  },
});
